import React, { useState } from 'react';
import Icon from '../common/Icon';

const AddCustomFilterField = ({
  fieldsets,
  uffIds,
  handleAddUserFilterField,
  filtersFull,
}) => {
  const [selectedField, setSelectedField] = useState(null);

  return (
    <>
      <header>
        <h3>Add Custom Filter</h3>
      </header>

      <div className='creation-form'>
        <div className='row'>
          <label>Add a field to customize your filters.</label>
          <div className='select-input'>
            <select
              name='fieldset'
              id='fieldset'
              onChange={(e) => setSelectedField(e.target.value)}
            >
              <option value=''>Select Field</option>
              {fieldsets.length > 0 &&
                fieldsets.map((fs) => {
                  return (
                    <optgroup key={fs.id} label={fs.name}>
                      {fs.fields.map((field) => {
                        return (
                          <option
                            key={field.id}
                            value={field.id}
                            disabled={uffIds.includes(field.id)}
                          >
                            {field.name}
                          </option>
                        );
                      })}
                    </optgroup>
                  );
                })}
            </select>
          </div>
        </div>

        {filtersFull && (
          <span className='errors'>
            Form already has maximum number of filters.
          </span>
        )}
        <div className='controls'>
          <button
            className='single'
            disabled={filtersFull}
            onClick={() => handleAddUserFilterField(selectedField)}
          >
            Add
            <Icon icon='plus' />
          </button>
        </div>
      </div>
    </>
  );
};

export default AddCustomFilterField;
